import { useAuth } from '@/lib/AuthContext';
import useStripeRedirectToast from '@/hooks/useStripeRedirectToast';
import UpgradeCard from '@/components/gbusiness/SubscriptionCard';
import PreciosV3 from '@/pages/v3/PreciosV3';

/**
 * PreciosSegunSesion — lo que sirve `/pricing` (y sus traducciones) en el SPA.
 *
 * `/pricing` no es solo una página de marketing: es también el destino de los
 * CTAs de DENTRO de la app que mandan a contratar (`SentimentLockedCard`,
 * `SeatActionPanel`, `ConnectionList`), la vuelta del registro con
 * `?autocheckout=1` (`SubscriptionCard`, el auditor SEO) y la vuelta de Stripe
 * al cancelar (`STRIPE_CHECKOUT_CANCEL_PATH = /pricing?stripe=cancel`).
 *
 * Mientras no hubo página, ninguno de esos caminos llegaba a nada útil: una
 * carga completa caía en el 301 de nginx a la home, y un `navigate()` en el
 * 404 del SPA. Y el `?autocheckout=1` se perdía por el camino, así que quien
 * se registraba desde un botón de «empezar prueba» nunca llegaba a Stripe.
 *
 * Por eso la página se parte en dos según la sesión, igual que la de la V2:
 *
 *  - Anónimo → `PreciosV3`, la página pública con la tabla, el FAQ y el cierre.
 *  - Con sesión → `<UpgradeCard />`, que ya resuelve todos los casos: dispara
 *    el checkout del `?autocheckout=1`, deja contratar a un free, y a un Pro o
 *    a quien tiene un impago le enseña su tarjeta en vez de dejarle pagar otra
 *    vez. Enseñarle la tabla pública sería mandarle a «crear cuenta».
 *
 * Esto vive aparte de `PreciosV3` y SOLO lo monta `App.jsx`: el prerender
 * (`entry-server.jsx`) no tiene `AuthProvider` y monta `PreciosV3` directo, que
 * es además lo que tiene que ver el crawler.
 */
export default function PreciosSegunSesion() {
  // Sin `Layout`, así que el toast de vuelta de Stripe (`?stripe=cancel`) lo
  // tiene que poner la propia página.
  useStripeRedirectToast();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) return <PreciosV3 />;

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-[968px] mx-auto px-4 sm:px-6 py-16 md:py-24">
        <UpgradeCard ctaId="precios.sesion.empezar-trial" />
      </div>
    </div>
  );
}
